import React from 'react'

const UserIcon = () => {
    return (
        <svg className='user-icon' data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 136.67 135">

            <path className="uicon" d="M133.71,135H2.96c-1.84,0-3.25-1.67-2.91-3.48,6.08-32.18,34.34-56.52,68.28-56.52s62.2,24.34,68.28,56.52c.34,1.81-1.07,3.48-2.91,3.48Z" />
            <circle className="uicon" cx="68.49" cy="40.09" r="40.09" />
        </svg>
    )
}

export default UserIcon
